/* eslint-disable prettier/prettier */
import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import CustomLink from "@gcloud-npm/next12.components.custom-link";
import Icon, { ICON_COLOR } from "@gcloud-npm/next12.components.icon";
import Switch from "@gcloud-npm/next12.components.switch";
import TextInfo, { TEXT_INFO_COLOR, TEXT_INFO_SIZE } from "@gcloud-npm/next12.components.text-info";
import {
  actions as modalActions,
  ELEMENT_TYPES,
} from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import { SWITCH_OPTIONS, TABS_IDS } from "@/utils/constans";
import styles from "./styles";

const Modal = (props) => {
  const { defaultValue } = props
  const [activePersonal, setActivePersonal] = useState(defaultValue === TABS_IDS.PLAN_PERSONAL);
  const [activeFamily, setActiveFamily] = useState(defaultValue === TABS_IDS.PLAN_FAMILIAR);
  const dispatch = useDispatch();

  const myTaggingInfo = {
    componentName: "ModalClientCar",
    componentVariation: "all",
    componentProduct: "",
  };

  const onClickHandler = () => {
    dispatch(
      modalActions.addModal({
        type: ELEMENT_TYPES.MODAL,
        id: '',
      })
    );
  };

  const onChangeTabs = (value) => {
    if (value === TABS_IDS.PLAN_PERSONAL) {
      setActivePersonal(true);
      setActiveFamily(false);
    } else {
      setActivePersonal(false);
      setActiveFamily(true);
    }

  }
  return (
    <>
      <div className="modalCliente">
        <div className="modal__header">
          <img
            loading="lazy" alt="Logotipo Movistar"
            src="https://prod.cms.col.movistar.es/sites/novum/movistar-salud/static/img/m-logo-color.svg"
            width="300" height="150" className="img-fluid" 
          />
          <CustomLink
            className="modal__close"
            onClick={onClickHandler}
            taggingInfo={myTaggingInfo}
            title="Cerrar modal"
            ariaLabel="Cerrar modal"
          >
            <Icon id="Cerrar" segment="gp" color={ICON_COLOR.GREY_6} size={14} />
          </CustomLink>
        </div>
        <div className="modalTit">Selecciona el plan que te interesa:</div>
        <Switch
          id="planpersonal"
          defaultValue={defaultValue}
          optionSize="double"
          onChange={onChangeTabs}
          options={SWITCH_OPTIONS}
        />
        <div className="modalTit">Elige una de estas opciones:</div>
        <div className="options" id="planpersonal" style={activePersonal ? {display: 'block'} :{display: 'none'}}>
          <div className="modalOpcion">
            <CustomLink
              taggingInfo={{
                ...myTaggingInfo,
                componentContent: "Soy cliente de Movistar",
              }}
              href="https://www.movistar.es/mimovistar-cliente/publico/acceso/privado/movistarSaludCompra?codCompAlta=C0032599&codServicio=00103001&productOffering=1071+410&pid=clic-boton-meinteresa-caja-personal"
              forceExternal
            >
              <div className="row">
                <TextInfo
                  className="padding0 margin0 col-xs-10"
                  color={TEXT_INFO_COLOR.GREY_9}
                  text="Soy cliente de Movistar"
                  size={TEXT_INFO_SIZE.CAPTION1}
                />
                <Icon className="padding0 margin0 col-xs-2" color={ICON_COLOR.GREY_9} id="CheuronRight" />
              </div>
            </CustomLink>
          </div>
          <div className="modalOpcion">
            <CustomLink
              taggingInfo={{
                ...myTaggingInfo,
                componentContent: "No soy cliente de Movistar",
              }}
              href="https://www.movistar.es/particulares/Aplicaciones/formulario-manual-base/?product=025&pid=clic-boton-meinteresa-caja-personal-nocliente"
              forceExternal
            >
              <div className="row">
                <TextInfo
                  className="padding0 margin0 col-xs-10"
                  color={TEXT_INFO_COLOR.GREY_9}
                  text="No soy cliente de Movistar"
                  size={TEXT_INFO_SIZE.CAPTION1}
                />
                <Icon className="padding0 margin0 col-xs-2" color={ICON_COLOR.GREY_9} id="CheuronRight" />
              </div>
            </CustomLink>
          </div>
        </div>
        <div className="options" id="planfamiliar" style={activeFamily ? {display: 'block'} :{display: 'none'}}>
          <div className="modalOpcion">
            <CustomLink
              taggingInfo={{
                ...myTaggingInfo,
                componentContent: "Soy cliente de Movistar",
              }}
              href="https://www.movistar.es/mimovistar-cliente/publico/acceso/privado/movistarSaludCompra?codCompAlta=C0032597&codServicio=00103001&productOffering=1072+410&pid=clic-boton-meinteresa-caja-familiar"
              forceExternal
            >
              <div className="row">
                <TextInfo
                  className="padding0 margin0 col-xs-10"
                  color={TEXT_INFO_COLOR.GREY_9}
                  text="Soy cliente de Movistar"
                  size={TEXT_INFO_SIZE.CAPTION1}
                />
                <Icon className="padding0 margin0 col-xs-2" color={ICON_COLOR.GREY_9} id="CheuronRight" />
              </div>
            </CustomLink>
          </div>
          <div className="modalOpcion">
            <CustomLink
              taggingInfo={{
                ...myTaggingInfo,
                componentContent: "No soy cliente de Movistar",
              }}
              href="https://www.movistar.es/particulares/Aplicaciones/formulario-manual-base/?product=024&pid=clic-boton-meinteresa-caja-familiar-nocliente"
              forceExternal
            >
              <div className="row">
                <TextInfo
                  className="padding0 margin0 col-xs-10"
                  color={TEXT_INFO_COLOR.GREY_9}
                  text="No soy cliente de Movistar"
                  size={TEXT_INFO_SIZE.CAPTION1}
                />
                <Icon className="padding0 margin0 col-xs-2" color={ICON_COLOR.GREY_9} id="CheuronRight" />
              </div>
            </CustomLink>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default Modal;
